// import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import HomePage from './pages/HomePage';
// import ProjectDetails from './pages/ProjectDetails';
import { Toaster } from "./components/ui/toaster";

// import Header from './components/Header'
function App() {
  return (
    <div className="App">
      {/* <BrowserRouter> 
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/project/:id" element={<ProjectDetails />} />
        </Routes>
      </BrowserRouter> */}
      <HomePage /> 
      <Toaster />
    </div>
    );
}
 
export default App;
